import {svgIconWrapper} from '../svg-icon-wrapper';

import QuoRegular from './quo-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <QuoRegular {...props} />;
}

SvgComponent.iconName = 'quoRegular';

export const QuoRegularIcon = svgIconWrapper(SvgComponent);
